import CatalogManager from "../components/CatalogManager";

export default function SuperAdminProducts() {
  return <CatalogManager kind="products" />;
}
